import { render, staticRenderFns } from "./OldProductPicker.vue?vue&type=template&id=25b69e4c&scoped=true"
import script from "./OldProductPicker.vue?vue&type=script&lang=js"
export * from "./OldProductPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b69e4c",
  null
  
)

export default component.exports